import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Tabs } from 'antd';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import {
	ClientInfoForm,
	BankInfoForm,
	BillingInfoForm,
	DocumentInfoForm,
	ShippingInfoForm,
	OtherInfoForm,
} from 'components/forms';
import { Box } from 'atoms';
import { getClientList } from 'store/clientSlice';

export default function AddClientPage() {
	const [formData, setFormData] = useState({});
	const [activeTab, setActiveTab] = useState(1);
	const [searchParams, setSearchParams] = useSearchParams();
	const dispatch = useDispatch();
	const { id } = useParams();

	const onChange = useCallback(
		(key) => {
			/**
			 * On Edit mode only allow to go other other tabs
			 */
			if (id) {
				const newQueryParameters = new URLSearchParams();
				console.log('newQueryParameters', newQueryParameters);
				setSearchParams({
					...newQueryParameters,
					tab: key,
					isEdit: searchParams.get('isEdit') || false,
				});
				setActiveTab(key);
			}
		},
		[id, setSearchParams, searchParams]
	);

	useEffect(() => {
		const tab = Number(searchParams.get('tab'));

		if (tab) {
			onChange(tab);
		}
	}, [onChange, searchParams]);

	useEffect(() => {
		console.log('Client Form activeTab', activeTab);
	}, [activeTab]);

	useEffect(() => {
		if (id) {
			// console.log('id 2', id);
			dispatch(
				getClientList({
					search_type: 'client',
					filter_by: {
						id,
					},
				})
			).then((res) => {
				// console.log(res);
				// console.log('res', res?.data?.[0]);
				setFormData(res?.data?.[0]);
			});
		}
	}, [dispatch, id]);

	const tabs = useMemo(
		() => [
			{
				id: 1,
				label: 'Client Details',
				form: (
					<ClientInfoForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={formData?.client_info}
						activeTab={activeTab}
					/>
				),
			},
			{
				id: 2,
				label: 'Bank Details',
				form: (
					<BankInfoForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={formData?.banking_info}
						activeTab={activeTab}
					/>
				),
			},
			{
				id: 3,
				label: 'Billing Details',
				form: (
					<BillingInfoForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={isEmpty(formData?.billing_info) ? [] : formData?.billing_info}
						activeTab={activeTab}
						billData={[]}
					/>
				),
			},
			{
				id: 4,
				label: 'Shipping Details',
				form: (
					<ShippingInfoForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={isEmpty(formData?.shipping_info) ? [] : formData?.shipping_info}
						activeTab={activeTab}
					/>
				),
			},
			{
				id: 5,
				label: 'Document Details',
				form: (
					<DocumentInfoForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={formData?.document_info}
						activeTab={activeTab}
					/>
				),
			},
			{
				id: 6,
				label: 'Other Details',
				form: (
					<OtherInfoForm
						isEditMode={Boolean(formData?.id)}
						otherFormsData={formData}
						formData={formData?.other_info}
						activeTab={activeTab}
					/>
				),
			},
		],
		[formData, activeTab]
	);

	return (
		<Box>
			<Tabs
				onChange={onChange}
				tabPosition="left"
				type="line"
				activeKey={activeTab}
				defaultActiveKey={1}
				items={tabs.map((tab) => ({
					label: `${tab.id}. ${tab.label}`,
					key: tab.id,
					children: tab.form,
				}))}
			/>
		</Box>
	);
}
